import { getClauseTypeForClauseListKey } from '@root/helpers/clauses';
import type { ClauseListKey } from '@root/helpers/clauses/types';
import { parseScheduleDatapointId } from '@root/helpers/schedules/constants';
import pluralize from 'pluralize';

export const getMentionLabelSegment = (id: string): string => {
  const lastSegment = id.split('.').pop()!;

  const schedule = parseScheduleDatapointId(id);
  if (schedule) {
    return schedule.datapointId.split('.').pop()!;
  }

  const clauseType = getClauseTypeForClauseListKey(id as ClauseListKey);

  if (clauseType) {
    const slug = clauseType.toLocaleLowerCase().replaceAll(' ', '_');
    return `list_of_${pluralize(slug)}`;
  }

  return lastSegment;
};
